var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"id":"dialog11123123123","title":"提示","visible":_vm.dialogVisible,"width":"20%","top":"10px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('iframe',{staticStyle:{"aspect-ratio":"430/932"},attrs:{"id":"dialog11123123123","src":_vm.url,"width":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }